import { useEffect, useState } from 'react';
import { AmariMark } from './Logo';

const SEEN = 'amari_splash_seen';
/** How long the logo stays up, counted from when the page started loading. */
const MIN_MS = 900;
const FADE_MS = 280;

function seenThisSession(): boolean {
  try { return sessionStorage.getItem(SEEN) === '1'; } catch { return false; }
}

/**
 * The launch splash: the same logo index.html draws before any script runs, kept up briefly once
 * per session and then faded out. It never takes taps, so it can't block the screen underneath.
 */
export function BootSplash() {
  const [phase, setPhase] = useState<'shown' | 'leaving' | 'gone'>(() => (seenThisSession() ? 'gone' : 'shown'));

  useEffect(() => {
    if (phase !== 'shown') return;
    try { sessionStorage.setItem(SEEN, '1'); } catch { /* private mode */ }
    const wait = Math.max(0, MIN_MS - performance.now());
    const leave = setTimeout(() => setPhase('leaving'), wait);
    const done = setTimeout(() => setPhase('gone'), wait + FADE_MS);
    return () => { clearTimeout(leave); clearTimeout(done); };
  }, [phase]);

  if (phase === 'gone') return null;
  return (
    <div className={`boot-splash${phase === 'leaving' ? ' is-leaving' : ''}`} aria-hidden>
      <AmariMark size={96} />
      <span className="boot-splash-name">Amari</span>
    </div>
  );
}
